import React, { useState } from 'react';
import { Card, Input, Select, Button } from '../../../shared/components';

const ReportFilters = ({ filters, onApply, onReset, showDateRange = true }) => {
  const [localFilters, setLocalFilters] = useState(filters || {
    startDate: '',
    endDate: '',
    period: 'daily',
    search: '',
    expiryStatus: 'all',
    stockStatus: 'all'
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLocalFilters(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onApply(localFilters);
  };

  return (
    <Card className="mb-6">
      <form onSubmit={handleSubmit} className="p-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          {showDateRange && (
            <>
              <div>
                <label className="block text-sm font-medium mb-1">Start Date</label>
                <Input
                  type="date"
                  name="startDate"
                  value={localFilters.startDate}
                  onChange={handleChange}
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">End Date</label>
                <Input
                  type="date"
                  name="endDate"
                  value={localFilters.endDate}
                  onChange={handleChange}
                />
              </div>
            </>
          )}
          
          {localFilters.period !== undefined && (
            <div>
              <label className="block text-sm font-medium mb-1">Period</label>
              <Select
                name="period"
                value={localFilters.period}
                onChange={handleChange}
              >
                <option value="daily">Daily</option>
                <option value="weekly">Weekly</option>
                <option value="monthly">Monthly</option>
                <option value="yearly">Yearly</option>
              </Select>
            </div>
          )}
          
          <div>
            <label className="block text-sm font-medium mb-1">Search</label>
            <Input
              type="text"
              name="search"
              placeholder="Search medicine..."
              value={localFilters.search || ''}
              onChange={handleChange}
            />
          </div>

          {localFilters.stockStatus !== undefined && (
            <div>
              <label className="block text-sm font-medium mb-1">Stock Status</label>
              <Select
                name="stockStatus"
                value={localFilters.stockStatus}
                onChange={handleChange}
              >
                <option value="all">All</option>
                <option value="low">Low Stock Only</option>
                <option value="adequate">Adequate Stock</option>
              </Select>
            </div>
          )}

          {localFilters.expiryStatus !== undefined && (
            <div>
              <label className="block text-sm font-medium mb-1">Expiry Status</label>
              <Select
                name="expiryStatus"
                value={localFilters.expiryStatus}
                onChange={handleChange}
              >
                <option value="all">All</option>
                <option value="expired">Expired</option>
                <option value="critical">Critical (≤30 days)</option>
                <option value="warning">Warning (≤90 days)</option>
                <option value="good">Good ({'>'}90 days)</option>
              </Select>
            </div>
          )}
        </div>
        
        <div className="flex justify-end gap-2 mt-4">
          <Button type="button" variant="secondary" onClick={onReset}>
            Reset
          </Button>
          <Button type="submit" variant="primary">
            Apply Filters
          </Button>
        </div>
      </form>
    </Card>
  );
};

export default ReportFilters;